import React, { useState, useEffect } from "react";
import {
  Form,
  Modal,
  Typography,
  message,
  Row,
  Col,
  Select,
  Input,
  Upload,
  Button,
  Checkbox,
  Space,
  Divider,
} from "antd";
import http from "../../../../../services/http";
import {
  EditOutlined,
  CloseCircleOutlined,
  CheckCircleOutlined,
  ClockCircleOutlined,
  DislikeOutlined,
  LikeOutlined,
  UploadOutlined,
  FileOutlined,
} from "@ant-design/icons";
import { createUUID } from "../../../../../helpers/generateUid";
const { Text, Paragraph } = Typography;
const { TextArea } = Input;

const options_status = [
  {
    value: -1,
    label: (
      <Text style={{ color: "#ff4d4f" }}>
        <DislikeOutlined /> Não aceito para realização
      </Text>
    ),
  },
  {
    value: 2,
    label: (
      <Text style={{ color: "#60b565" }}>
        <LikeOutlined /> Aceito para realização
      </Text>
    ),
  },
  {
    value: 0,
    label: (
      <Text style={{ color: "#ff4d4f" }}>
        <CloseCircleOutlined /> Não alcançado
      </Text>
    ),
  },
  {
    value: 1,
    label: (
      <Text style={{ color: "#60b565" }}>
        <CheckCircleOutlined /> Alcançado
      </Text>
    ),
  },
  {
    value: 3,
    label: (
      <Text style={{ color: "#1677ff" }}>
        <ClockCircleOutlined /> Aguardando Avaliação
      </Text>
    ),
  },
];

export const ModalAvaliacao = ({ id, open, onClose, onFinish, avaliador }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [dados, setDados] = useState(null);
  const files = Form.useWatch("files", form);

  useEffect(() => {
    if (id > 0) carregarAcaoAvaliacao(id);
  }, [id]);

  // RESET FORM
  const resetForm = () => {
    form.resetFields();
    setDados(null);
  };

  // CARREGAR AÇÃO
  const carregarAcaoAvaliacao = async (id) => {
    if (!id) return;
    setLoading(true);
    const api = await http("get", `v1/problemas_acoes/carregar/${id}`, []);
    if (api.statusCode === 200) {
      const response = api?.response?.data;
      resetForm();
      if (!response?.id) onClose();
      setDados(response);
      form.setFieldsValue({
        status: response?.status,
      });
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // CADASTRAR AÇÃO
  const cadastrarAcaoAvaliacao = async (formulario) => {
    setLoading(true);
    const api = await http("post", `v1/problemas_acoes/adicionar_parecer`, formulario, "multipart/form-data");
    if (api.statusCode === 200) {
      resetForm();
      onClose();
      message.success("Avaliação registrada com sucesso!");
      if (api?.response?.data?.concluido === 1) {
        onFinish(1);
      } else {
        onFinish(0);
      }
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // SUBMIT FORM
  const onSubmit = (formulario) => {
    const formData = new FormData();
    formData.append("id", id ?? 0);
    formData.append("parecer", formulario?.parecer ?? "");
    formData.append("enviar_notificacao", formulario?.enviar_notificacao ? 1 : 0);
    formData.append("status", formulario?.status ?? "");
    for (const f of formulario?.files ?? []) {
      formData.append("files[]", f?.originFileObj ?? "");
    }
    cadastrarAcaoAvaliacao(formData);
  };

  const handlePaste = (e) => {
    setLoading(true);
    if (e?.clipboardData?.files?.length) {
      if (files?.length >= 5) {
        setLoading(false);
        return;
      }

      const file = e?.clipboardData?.files[0];

      const arquivo = {
        uid: createUUID(),
        originFileObj: file,
        name: file?.name,
        lastModified: file?.lastModified,
        lastModifiedDate: file?.lastModifiedDate,
        type: file?.type,
        size: file?.size,
      };

      form?.setFieldsValue({ files: [...(files ?? []), arquivo] });
    } else {
      message.error("Nenhum arquivo selecionado!");
    }
    setLoading(false);
  };

  const formFile = (e) => {
    const size = e?.file?.size / 1024 / 1024 > 25;
    if (size) {
      message.error("Tamanho não suportado, máximo 25MB!");
      return null;
    }

    if (Array.isArray(e)) {
      return e;
    }
    return e?.fileList;
  };

  return (
    <Modal
      title={
        <Text style={{ fontSize: 20 }}>
          <EditOutlined /> Adicionar Parecer
        </Text>
      }
      open={open}
      onOk={() => form.submit()}
      okText="Salvar"
      width={1200}
      okButtonProps={{ size: "large", loading: loading }}
      cancelButtonProps={{ size: "large", loading: loading }}
      onCancel={() => {
        resetForm();
        onClose();
      }}>
      <Form onPaste={handlePaste} form={form} onFinish={onSubmit} layout="vertical" autoComplete="off">
        <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
          <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
            <Space direction="vertical">
              <Text style={{ fontSize: 18, color: "#60b565" }} strong>
                Ação (Como?)
              </Text>
              <Paragraph
                className="line-break"
                ellipsis={{
                  rows: 3,
                  expandable: true,
                }}>
                {dados?.descricao ?? ""}
              </Paragraph>
            </Space>
          </Col>

          <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
            <Space direction="vertical">
              <Text style={{ fontSize: 18, color: "#60b565" }} strong>
                Observações
              </Text>
              <Paragraph
                className="line-break"
                ellipsis={{
                  rows: 3,
                  expandable: true,
                }}>
                {dados?.observacoes ?? "-"}
              </Paragraph>
            </Space>
          </Col>

          <Divider />

          {avaliador && (
            <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item name="status" label="Status" rules={[{ required: true, message: "Informe o status!" }]}>
                <Select
                  size="large"
                  placeholder="Selecione o status"
                  disabled={loading}
                  style={{ width: "100%" }}
                  options={options_status}
                />
              </Form.Item>
            </Col>
          )}

          <Col className="gutter-row" span={24}>
            <Form.Item label="Observações" name="parecer" rules={[{ required: true, message: "Informe o parecer" }]}>
              <TextArea
                size="large"
                autoSize={{ minRows: 4, maxRows: 5 }}
                placeholder="Informe o parecer"
                disabled={loading}
              />
            </Form.Item>
          </Col>

          <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
            <Form.Item
              getValueFromEvent={formFile}
              name="files"
              valuePropName="fileList"
              label={
                <Text>
                  Anexos (Opcional) <Text type="secondary">Máx: 5</Text>
                </Text>
              }>
              <Upload
                iconRender={() => <FileOutlined />}
                listType="picture"
                disabled={loading}
                multiple
                beforeUpload={() => false}
                maxCount={5}>
                <Button loading={loading} size="large" icon={<UploadOutlined />}>
                  Click para enviar
                </Button>
              </Upload>
            </Form.Item>
          </Col>
          <Col className="gutter-row" span={24}>
            <Form.Item name="enviar_notificacao" valuePropName="checked" initialValue={true}>
              <Checkbox disabled={loading}>Enviar Notificações</Checkbox>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};
